import type { KeywordPin } from './types';

/**
 * Built-in keyword pins seeded into `localStorage` on first load.
 *
 * These match the design bundle (`/tmp/design-bundle/focused-view/project/data.jsx`,
 * `defaultKeywordPins`) verbatim. All four are `builtin: true`, meaning the UI
 * hides the delete button and forbids editing `label`/`keyword`. Other fields
 * (color, prompt, trigger, enabled) remain user-editable.
 */
export const DEFAULT_KEYWORD_PINS: ReadonlyArray<KeywordPin> = [
	{
		id: 'kp1',
		label: 'Game Plan',
		keyword: 'game plan',
		color: '#EA6A2C',
		prompt:
			'Give me a tactical game plan for this call. Cover: 1) 3 things I must say, 2) expected objections + rebuttals, 3) the close I should push for.',
		trigger: 'before_call',
		enabled: true,
		builtin: true,
	},
	{
		id: 'kp2',
		label: 'Battle Card',
		keyword: 'battle card',
		color: '#3B82F6',
		prompt:
			"Pull up the competitive battle card. Who are they likely evaluating against us, and what are the 3 hardest objections I'll hear?",
		trigger: 'on_dial',
		enabled: true,
		builtin: true,
	},
	{
		id: 'kp3',
		label: 'Give me a hook',
		keyword: 'give me a hook',
		color: '#8B5CF6',
		prompt:
			"Give me a one-sentence hook to open this call — something that earns the prospect's attention without sounding like a pitch.",
		trigger: 'starter',
		enabled: true,
		builtin: true,
	},
	{
		id: 'kp4',
		label: 'Give me a pitch',
		keyword: 'give me a pitch',
		color: '#10A37F',
		prompt:
			'Give me a tight 30-second pitch tailored to this prospect: who we are, why it matters to them specifically, and the single CTA I should push for.',
		trigger: 'starter',
		enabled: true,
		builtin: true,
	},
];
